<template>

    <v-container>

        <v-layout row wrap>

            <v-flex xs12 sm12 mb-2 pb-5>

            </v-flex>

        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm12>
                <v-layout row>
                    <v-flex xs12>
                        <v-card>
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12 md8>
                                        <v-card-title class="headline">
                                            Procurements
                                        </v-card-title>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="search"
                                                append-icon="search"
                                                label="Search"
                                                single-line
                                                hide-details
                                                clearable
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>

                            <v-data-table
                                    :headers="headers"
                                    :items="getItems"
                                    :pagination.sync="pagination"
                                    :total-items=total
                                    class="elevation-0"
                                    :loading="loading"
                                    :rows-per-page-items="rowsPageItems"
                            >

                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <v-touch tag="tr"
                                             @doubletap="openDialog(props.item.id)"
                                             @dblclick="openDialog(props.item.id)">
                                        <td>{{ props.item.id }}</td>
                                        <td class="text-xs-left">{{ props.item.purchase_order.purchase_orders_number
                                            }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.purchase_order.customer_purchase_order_number
                                            }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.purchase_order.customer.name }}</td>
                                        <td class="text-xs-left">{{ props.item.purchase_order.account.firstname }} {{
                                            props.item.purchase_order.account.lastname}}
                                        </td>
                                        <td class="text-xs-center">
                                            <v-progress-linear
                                                    slot="progress"
                                                    :value="calculateProgress(props.item.id)"
                                                    :color="color(props.item.id)"
                                                    height="7"
                                            ></v-progress-linear>
                                        </td>

                                        <td class="text-xs-center">
                                            {{ getPositionCount(props.item.procurements_positions) }} / {{
                                            props.item.procurements_positions.length }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.procurements_status.name }}</td>
                                        <td class="text-xs-left"> {{ props.item.created_at | toDateTimeLocalTime }}</td>
                                    </v-touch>

                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                </v-layout>


                <addProcurementDialog></addProcurementDialog>


            </v-flex>
        </v-layout>

    </v-container>

</template>

<script>
    import {
        Settings,
        Procurement
    } from '../../store/namespace-helper'
    import addProcurementDialog from '../Procurements/AddProcurementDialog.vue'
    import _ from 'lodash'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {stateHelperMixin} from '../../mixins/stateHelperMixin'

    export default {
      name: 'customers',
      components: {
        addProcurementDialog
      },
      mixins: [dateFunctionFilters, stateHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'Procurement-ID', value: 'id'},
            {
              text: 'Order Confirmation Number',
              value: 'purchase_orders:purchase_orders_id|purchase_orders.purchase_orders_number',
              sortable: true
            },
            {
              text: 'Customer Purchase Order Number',
              value: 'purchase_orders:purchase_orders_id|purchase_orders.customer_purchase_order_number',
              sortable: true
            },
                    {text: 'Customer', value: 'purchase_orders:purchase_orders_id|customers:customers_id|customers.name', sortable: true},
                    {text: 'Account', value: 'accounts_id', sortable: false},
                    {text: 'Progress', value: 'progress', sortable: false, align: 'left'},
                    {text: 'Confirmed Positions', value: 'calc_position', sortable: false, align: 'center'},
                    {text: 'Status', value: 'purchase_orders_status_id', sortable: false},
                    {text: 'Created', value: 'created_at'}
          ],
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [25, 10, 50, 100, 250]
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadItems()
      },
      methods: {
        openDialog (val) {
          if (val !== null) {
            var item = this.getItems.find(x => x.id === val)
            this.$store.dispatch(Procurement.actions.setSelectedProcurement, item)
          }
          this.$store.dispatch(Procurement.actions.openCloseDialog)
        },
        loadItems () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.$store.dispatch(Procurement.actions.loadProcurements, query)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        },
        color (val) {
          var item = this.getItems.find(x => x.id === val)
          if (this.getPositionCount(item.procurements_positions) === item.procurements_positions.length && item.procurements_positions.length !== 0) {
            return 'success'
          } else if (this.getPositionCount(item.procurements_positions) === 0) {
            return 'error'
          } else {
            return 'warning'
          }
        },
        calculateProgress (val) {
          if (val !== null) {
            var item = this.getItems.find(x => x.id === val)
            return (100 / item.procurements_positions.length) * this.getPositionCount(item.procurements_positions)
          } else {
            return 0
          }
        },
        getPositionCount (val) {
          var count = 0
          val.forEach(function (item) {
            if (item.procurements_positions_status_id >= 2) {
              count += 1
            }
          })
          return count
        }
      },
      computed: {
        getItems () {
          this.total = this.$store.getters[Procurement.getters.procurements].total
          return this.$store.getters[Procurement.getters.procurements].data
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        dialogState () {
          return this.$store.getters[Procurement.getters.getOpenDialogState]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        dialogState: {
          handler (val) {
            if (!val) {
                        // cleanup states
                        // reload supplier list
              this.throttledLoadItems()
            }
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>


// WEBPACK FOOTER //
// src/components/Procurements/Procurements.vue